import React from "react";
import { useTranslation } from 'react-i18next';
import About from "../Components/about/About";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import seoData from "../data/seoData.json";

function AboutPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = seoData[currentLang]?.about || seoData.en.about;

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/hakkimizda"
      />
      <TopBar />
      <Spacer/><Spacer />
      <About />
    </>
  );
}

export default AboutPage;
